import React, { Fragment, useEffect } from 'react';
import { 
  BrowserRouter, 
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import './App.css';
import './components/layout/Navbar';
import './components/layout/Landing';
import Navbar from './components/layout/Navbar';

//Redux
import { Provider } from 'react-redux';
import store from './store';
import setAuthToken from './utils/setAuthToken';
import { loadUser } from './actions/auth';
import AllRoutes from '../src/components/routing/AllRoutes';
import Alert from '../src/components/layout/Alert';

if(localStorage.token){
  setAuthToken(localStorage.token)
}

const App = () => {
  // useEffect runs infinite , [] -> to make run once on load
  useEffect(() => {
    // Load user to check authentication status
    store.dispatch(loadUser());
  }, []);

	return (
		<Provider store={ store }>
			<BrowserRouter>
				<div className="app-container">
					<Navbar />
					<div className="main-content-wrapper">
						<Alert key='all-alert'/>
						<Routes>
							<Route  path='/'  element={ <Navigate to={`/inventory/${process.env.REACT_APP_BUILD_VERSION}/`}/>}/>
							<Route path="/*" element={<AllRoutes />} />
						</Routes>
					</div>
				</div>
      		</BrowserRouter>
    	</Provider> 
	)
};

export default App;
